import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupFoodDrinkList } from '@shared/api/types';
import { useGroupFoodAndDrinkColumns } from './group-food-and-drink-table-columns';
import { FilterOption, toFilterOptions } from './group-purchased-goods-columns';

interface GroupFoodAndDrinkTableProps
  extends DataTableProps<PaginatedGroupFoodDrinkList> {
  pageCount: number;
}

export default function GroupFoodAndDrinkTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupFoodAndDrinkTableProps) {
  const filters = data?.filters;

  const ratingOptions: FilterOption[] = toFilterOptions(
    filters?.emissionsCategories
  );
  const familyOptions: FilterOption[] = toFilterOptions(filters?.families);
  const supplierOptions: FilterOption[] = toFilterOptions(filters?.suppliers);

  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupFoodAndDrinkColumns({
      ratingOptions,
      familyOptions,
      supplierOptions,
    }),
    pageCount,
    initialState: {
      columnVisibility: {
        family: false,
        supplier: false,
      },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
